<template>
  <div>
    <div v-if="type == 1">
      <div style="font-size: 20px;font-weight: bold;padding: 20px;">
        {{name}}님, 퇴직금 찾기 신청이 완료되었습니다.
      </div>
      <div style="padding: 20px;">
        안녕하세요, {{name}}님. </br></br>

        퇴직금 찾기 서비스 신청이 정상적으로 접수되었습니다.</br></br>

        노무법인 유연 담당자가 내용을 꼼꼼히 검토한 후, 다음 진행 상황을 다시 안내해 드리겠습니다.</br></br>

        ■ 신청자명: {{name}}</br></br>
        ■ 신청일시: {{time}}</br>
      </div>
    </div>
    <div v-if="type == 2">
      <div style="font-size: 20px;font-weight: bold;padding: 20px;">
        {{name}}님, 신청하신 건의 검토가 시작되었습니다
      </div>
      <div style="padding: 20px;">
        안녕하세요, {{name}}님.</br>
        신청하신 퇴직금 찾기 건에 대해 담당 노무사가 배정되어 검토를 시작하였습니다.</br></br></br></br>
        검토 완료 후 결과에 대해 안내드리겠습니다.
      </div>
    </div>
    <div v-if="type == 3">
      <div style="font-size: 20px;font-weight: bold;padding: 20px;">
        {{name}}님, 퇴직금 찾기 신청이 완료되었습니다.
      </div>
      <div style="padding: 20px;">
        안녕하세요, {{name}}님.</br></br>
        퇴직금 찾기 서비스 신청이 정상적으로 접수되었습니다.</br></br>

        노무법인 유연 담당자가 내용을 꼼꼼히 검토한 후, 다음 진행 상황을 다시 안내해 드리겠습니다.</br></br>

        ■ 신청자명: {{name}}</br></br>
        ■ 신청일시: {{time}}</br></br>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import { getAction } from '@/network/manage';
  import moment from 'moment/moment';
  export default {
    name: 'Message',
    components: {

    },
    data() {
      return {
        uuid: '',
        name: "xxxxxxxx",
        time: "2025-10-20",
        type: 0
      }
    },
    mounted() {
      this.uuid = this.$route.params.uuid
      this.type = this.$route.query.t
      this.initDate()
    },
    methods:{
      async initDate(){
        this.loading = true
        const res = await getAction('/app/applicationRecord/getInfo/' + this.uuid)
        this.name = res.result.name
        this.time = res.result.signingAt
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{position: absolute;height: 100vh;display: flex;flex-direction: column;align-items: center;width: 100%;justify-content: center;text-align: center;}
  h1{color:#333333;font-size: 24px;line-height: 34px;}
  .btn{font-size:22px;display: flex;justify-content: center;background:#4873FF;margin-top:40px;align-items: center;padding:0 30px;height: 52px;border-radius: 26px;color:#ffffff;font-weight: bold;}
  .btn img{width: 22px;margin-right: 10px;}
  .bg{position: absolute;top:0;left:0;width: 100%;}
</style>
